import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "./ui/accordion";
import { FAQ as FAQ_ITEMS, buildWhatsAppLink } from "../lib/brand";
import { WhatsappLogo } from "@phosphor-icons/react";

export default function FAQ() {
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="py-20 sm:py-28 border-t border-white/10"
    >
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-10">
        <div className="mb-10 sm:mb-14">
          <div className="label-eyebrow mb-3">[ Perguntas frequentes ]</div>
          <h2 className="font-display font-bold text-white text-3xl sm:text-5xl tracking-tight">
            Dúvidas comuns de quem<br />
            <span className="text-[var(--rc-copper-bright)]">vende metais em Maringá.</span>
          </h2>
        </div>

        <Accordion type="single" collapsible className="rc-grid-border bg-[var(--rc-surface)]">
          {FAQ_ITEMS.map((item, i) => (
            <AccordionItem
              key={i}
              value={`faq-${i}`}
              data-testid={`faq-item-${i}`}
              className="border-b border-white/10 last:border-b-0 px-5 sm:px-7"
            >
              <AccordionTrigger className="text-left text-white font-display font-bold text-base sm:text-lg py-5 sm:py-6 hover:no-underline">
                {item.q}
              </AccordionTrigger>
              <AccordionContent className="text-zinc-300 text-sm sm:text-base leading-relaxed pb-6">
                {item.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>

        <div className="mt-10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 bg-[var(--rc-surface-2)] border border-white/10 p-6 sm:p-8">
          <div>
            <div className="font-display font-bold text-white text-xl">
              Ficou alguma dúvida?
            </div>
            <div className="text-zinc-400 text-sm mt-1">
              Mande sua pergunta pelo WhatsApp — respondemos em horário comercial.
            </div>
          </div>
          <a
            href={buildWhatsAppLink("Olá! Tenho uma dúvida sobre a compra de metais.")}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="faq-whatsapp-btn"
            className="rc-btn-whatsapp inline-flex items-center gap-2 px-5 py-3 rounded-md"
          >
            <WhatsappLogo size={18} weight="fill" />
            <span className="font-display font-bold">Falar no WhatsApp</span>
          </a>
        </div>
      </div>
    </section>
  );
}
